import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../../components/common/SpinnerComponentUI'
import DsraEventListModalSF from './DsraEventListModalSF'

const DsraEventListUI = ({ context, account, loan, dsraEvent, dsraEventList, onRefreshClick,
  dsraEventListUpdated, onDsraEventListUpdateClick, onDsraEventListCancelClick
}) =>
  <CardUI className='su_amrt'>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          {
            context.permissions.includes('su_manage') &&
            <IconButtonUI icon='icon-plus' onClick={onDsraEventListUpdateClick} />
          }
          <span className='g_m_left_50'><b>DSRA status across all loans</b></span>
          <DsraEventListModalSF context={context} account={account} loan={loan}
            updateMode={dsraEventListUpdated} onCancelClick={onDsraEventListCancelClick}
            onRefreshClick={onRefreshClick}
          />
        </span>
      }
      right={<span />}
    />
    {
      dsraEventList && !dsraEventList.length &&
      <span>No DSRA events</span>
    }
    {
      dsraEventList && dsraEventList.length > 0 &&
      <table><tbody>
        <tr>
          <td className='g_text_center'><b>Date</b></td>
          <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>Total</b></td>
          <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>Current</b></td>
          <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>Dipped</b></td>
          <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>Status</b></td>
        </tr>
        {
          dsraEventList.map((event, i) =>
            <tr key={i}>
              <td className='g_text_center'><span>{event.dateF1}</span></td>
              <td className='g_text_right'><span className='g_m_left_100'>{event.dsraTotalF5}</span></td>
              <td className='g_text_right'><span className='g_m_left_100'>{event.dsraCurrentF5}</span></td>
              <td className='g_text_right'><span className='g_m_left_100'>{event.dsraDippedF5}</span></td>
              <td className='g_text_right'><span className='g_m_left_100'>{event.status}</span></td>
            </tr>
          )
        }
      </tbody></table>
    }
    {
      dsraEvent &&
      <div className='g_flex_v g_m_top_100'>
        <span>DSRA dipped {dsraEvent.dsraDipCount ? dsraEvent.dsraDipCount : '0'} times</span>
        <span>DSRA dipped for {dsraEvent.dsraDipDaysCount ? dsraEvent.dsraDipDaysCount : '0'} days</span>
      </div>
    }
  </CardUI>

export default DsraEventListUI
